/**
 * Endpoint configuration for release cloud access.
 *
 * Portal URLs are sourced from the build-time environment (`.env`, injected as
 * `process.env.REACT_APP_*`) so that no endpoint literal is hard-coded in component source,
 * mirroring `kustoAccessConfig.ts` and keeping the Breeze "Hard-Coded Endpoints" scanner satisfied.
 *
 * Dynamic key access works because CRA's DefinePlugin substitutes the whole `process.env` object,
 * which is the same mechanism `SlaUtils.getSLA` and `kustoAccessConfig.getKustoCluster` rely on.
 */

/** SRM portal for a cloud. Empty when that cloud has no portal deployed yet (e.g. GovSG). */
export const getPortalUrl = (cloudKey: string): string =>
    process.env[`REACT_APP_PORTAL_${cloudKey.toUpperCase()}_URL`] ?? '';

/** Customer support and cloud-access documentation. */
export const SRM_SUPPORT_URL =
    process.env.REACT_APP_SRM_ENVIRONMENTS_DOC_URL ?? '';
